import React from 'react';
import {
  FlexRow,
  FlexCol,
  TextDynamic,
  BodyText,
  DetailTextLarge,
  BasicContainer,
  FlexDynamic,
} from '@minecraft.atoms';
import { appConfig } from '@minecraft.app-config';

const TestimonialImageWithBG = () => {
  return (
    <BasicContainer
      alignSelf="center"
      w="32"
      h="32"
      bgColor="paywallLight"
      borderRadius="full"
      className="cn_relative"
      mdProps={{ mt: '3', w: '48', h: '48' }}
    >
      <FlexCol
        data-testid="paywall-registration-testimonial-img"
        className="cn_absolute"
        top={-0.5}
        w="32"
        h="34"
        borderRadius="full"
        backgroundImage={{
          image: `${appConfig.cdnRoot}/images/static/JasminCowan.png`,
          size: '8rem',
          position: 'top',
          repeat: 'no-repeat',
        }}
        mdProps={{
          mt: '3',
          w: '48',
          h: '52',
          top: -1.75,
          backgroundImage: {
            image: `${appConfig.cdnRoot}/images/static/JasminCowan.png`,
            size: '12rem',
            position: 'top',
            repeat: 'no-repeat',
          },
        }}
      />
    </BasicContainer>
  );
};

export const RegistrationTestimonial = () => {
  return (
    <FlexDynamic
      alignItems="flex-start"
      direction="column"
      mdProps={{ direction: 'row', mt: '8' }}
      className="cn_relative"
      data-testid="paywall-registration-testimonial"
    >
      <TestimonialImageWithBG />
      <FlexCol className="cn_absolute" top={6.5} mdProps={{ top: 0, left: 11.5 }}>
        <TextDynamic fontSize="xxxl" fontWeight="bold" color="paywallLight">
          “
        </TextDynamic>
      </FlexCol>
      <FlexCol gap="2" mt="4" mdProps={{ w: '1/2', ml: '4' }}>
        <FlexRow wrap="nowrap">
          <FlexCol gap="4">
            <BodyText textWrap="balance">
              Casting Networks opened up a whole new world to me. I could see what casting directors were casting and
              look at roles. I self booked roles that changed my life and I built relationships with casting directors.
              I am forever thankful for this service...
            </BodyText>
            <FlexCol gap="1">
              <BodyText fontWeight="medium">Jasmine Cowen</BodyText>
              <DetailTextLarge>Member since 2014</DetailTextLarge>
            </FlexCol>
          </FlexCol>
        </FlexRow>
      </FlexCol>
    </FlexDynamic>
  );
};
